export default __webpack_public_path__ + "static/media/application-fellowship-23-24-1.bffa6f94.pdf";